<mat-card-header>
<div style="width:90%">
    <mat-card-title>
    <label class="mat-h2 bold">ATENÇÃO</label>
    </mat-card-title>
</div>
<div style="width:10%; cursor:pointer;">
    <mat-icon style="position: relative; float: right; margin-right: 5px" (click)="closePopup()">cancel</mat-icon>
</div>
</mat-card-header>
<mat-card-content style="width: 700px">
    <div fxLayout="row" fxLayout.xs="column" >
        <label class="mat-h4 bold">VOCÊ ESTÁ SOLICITANDO UM ADIANTAMENTO!!!</label>
    </div>
    <div fxLayout="row" fxLayout.xs="column" >
        <label class="mat-h4 bold">Essa modalidade de pagamento é de uso restrito (conforme procedimento da Companhia) e devem atender aos requisitos abaixo mencionados:</label>
    </div>
    <div fxLayout="row" fxLayout.xs="column" >
        <label class="mat-h5">1.	Declaro estar ciente que deverá ser efetuado, tão logo seja pago, a prestação de contas para utilização deste valor, sendo que os gastos deverão ser justificados através dos documentos comprobatórios correspondentes.</label>
    </div>
    <div fxLayout="row" fxLayout.xs="column" >
        <label class="mat-h5">2.	Declaro ser de meu conhecimento que o valor disponibilizado destina-se única e exclusivamente ao exercício das atividades da Companhia, tendo ciência que a utilização para outros fins implica em séria violação dos deveres e obrigações da relação empregatícia, nos termos da Consolidação das Leis Trabalhistas (art. 482);</label>
    </div>
    <div fxLayout="row" fxLayout.xs="column">
        <label class="mat-h5">3.	Declaro que o adiantamento solicitado já teve possíveis impostos / descontos deduzidos para que o valor pago reflita exatamente com o valor líquido do documento comprobatório.</label>
    </div>
    <div fxLayout="row" fxLayout.xs="column">
        <label class="mat-h5">4.	Declaro ter ciência que o adiantamento pode vir a comprometer outras liberações de pagamento para o(s) referido(s) fornecedor(es), até que seja regularizado o valor adiantado.
        </label>
    </div>
    <div fxLayout="row" fxLayout.xs="column" >
        <label class="mat-h5">5.	Declaro ter ciência que o valor solicitado deve ser utilizado integralmente para o Empreendimento / Divisão pertinente à solicitação do recurso para que o lançamento das despesas comprobatórias possam ser vinculadas corretamente.</label>
    </div>
    <div fxLayout="row" fxLayout.xs="column">
        <label class="mat-h5">6.	Declaro ter ciência que o descumprimento dos itens acima citados são de minha inteira responsabilidade e acarretará na cobrança do setor financeiro/contábil no que tange a regularização da situação, e de eventuais auditorias (internas e externas) que possam ocorrer no processo.</label>
    </div>

</mat-card-content>
<mat-action-row class="footer">
    <button mat-button color="warn" (click)="closePopup()"  matTooltip="Caso não concorde os dados preenchidos neste formulário serão perdidos">Cancelar</button>
    <button id="btnTipoDoc" mat-button color="primary" class="btn-primary-xl" (click)="agreePopup()">Li e aceito as condições nesse termo</button>
</mat-action-row>
